import React from "react";
import loaderSidebar from '../images/loader-sidebar.svg';
import loaderContent from '../images/loader-content.svg';
import loaderMobile from '../images/loader-mobile.svg';
import {useSelector} from "react-redux";

export const LoadingPage = () => {
    const isMobile = useSelector(state => state.app.isMobile)
    document.title = 'Loading'
    return (
        <section className="loader">
            <div className="loader__head"/>
            {
                isMobile && (
                    <div className="container app-box">
                        <div className="container__wrap">
                            <div className="loader__content">
                                <img src={loaderMobile} alt="" title=""/>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                !isMobile && (<div className="container app-box">
                    <div className="loader__sidebar">
                        <div className="container__sidebar_wrap">
                            <img src={loaderSidebar} alt="" title=""/>
                        </div>
                    </div>
                    <div className="container__content_wrap">
                        <div className="loader__content">
                            <img src={loaderContent} alt="" title=""/>
                        </div>
                    </div>
                </div>)
            }

            <div className="loader__foot"/>
        </section>)
}